// extracted by mini-css-extract-plugin
module.exports = {"lifeImage":"lives_lifeImage__121KY","deadImage":"lives_deadImage__2SCOT"};